import { render, staticRenderFns } from "./DeliveryNoteEditor.vue?vue&type=template&id=0b9b53d6&"
import script from "./DeliveryNoteEditor.vue?vue&type=script&lang=js&"
export * from "./DeliveryNoteEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports